import * as S from "./style";
//Components
import ActionButtonResponsy from "../../Button/ActionButtonResponsy";
import ActionButton from "../../Button/ActionButton";
import InputSearch from "../../FieldSearch";
import PopMenu from "../../PopMenu";

import CreateBrainds from "../../Modals/Brainds/Create";
import CreateFrame from "../../Modals/Frame/Create";
import CreateMaterial from "../../Modals/Material/Create";
import CreateSupplier from "../../Modals/Supplier/Create";

import CreateAntiGlare from "../../Modals/AntiGlare/Create";
import CreateDiameter from "../../Modals/Diameter/Create";
import CreateHeight from "../../Modals/Height/Create";
import CreateIndice from "../../Modals/Indice/Create";
import CreateLens from "../../Modals/Lens/Create";
import CreateSurfacing from "../../Modals/Surfacing/Create";

import CreateLaboratory from "../../Modals/Laboratory/Create";
import CreateSensitivity from "../../Modals/Sensitivity/Create";
import CreateTypeLens from "../../Modals/TypeLens/Create";

import CreateCategory from "../../Modals/Expense/Category/Create";
import CreateExpenses from "../../Modals/Expense/Create";

import CreateRetr from "../../Modals/Retroactive/Create";

import Toast from "../../Toast";

import FilterTable from "../../Filter/FilterButtonTable";
//Hooks
import { useMultipleModal } from "../../../hooks/useMultipleModal";
//Icons
import { CaretDown, Export } from "@phosphor-icons/react";
import { useState } from "react";

export interface ITitle {
  title: string;
  subtitle: string;
  placeholderSearch: string;
  listPopMenu: string[];
  listPopButton?: string[];
  fetchData: () => void;
  filterSearch: (search: string) => void;
  exportButton?: () => void;

  visibleButton?: boolean;
  visibleButtonExport?: boolean;

  filtersTitle: IFilter[];
  onApplyFilters: (filters: Record<string, string | number>) => void;
  onClearFilters: () => void;
  initialValues?: Record<string, string | number>;
}

interface IFilterOption {
  id?: string | number;
  value: string | number;
}

// Interface para um filtro individual
interface IFilter {
  key: string;
  title: string;
  data: IFilterOption[] | string[]; // Suporta tanto objetos quanto strings simples
}

export default function TitleFilter({
  title,
  subtitle,
  placeholderSearch,
  listPopMenu,
  listPopButton,
  fetchData,
  filterSearch,
  exportButton,
  visibleButton = true,
  visibleButtonExport = true,
  filtersTitle,
  onApplyFilters,
  onClearFilters,
  initialValues
}: ITitle) {
  const { isOpenModal, toggleModalVisibility, assignRef } = useMultipleModal();
  const [toastData, setToastData] = useState({
    status: 200,
    message: "",
  });

  const handleInputChange = (inputSearch: string) => {
    filterSearch(inputSearch);
  };

  return (
    <S.Container>
      <S.Title>
        <S.H4>{title}</S.H4>
        <S.H6>{subtitle}</S.H6>
      </S.Title>

      <S.ContentSearch>
        <InputSearch name={placeholderSearch} onSearch={handleInputChange} />

        <S.ContentButton>
          {
            visibleButtonExport &&
            <ActionButtonResponsy
              name="Exportar"
              Icon={<Export size={20} weight="bold" />}
              onClick={exportButton}
            />
          }

          <FilterTable
            filters={filtersTitle || []}
            onApplyFilters={onApplyFilters}
            onClearFilters={onClearFilters}
            initialValues={initialValues || {}}
          />

          {visibleButton && (
            <S.ContentPopButton>
              <ActionButton
                name="Novo Cadastro"
                Icon={<CaretDown size={20} weight="fill" />}
                onClick={() => toggleModalVisibility("menu")}
              />
              {isOpenModal("menu") && (
                <div ref={(ref) => assignRef("menu", ref)}>
                  <PopMenu
                    listName={listPopMenu}
                    onClickHandlers={listPopButton?.map((val) => {
                      return () => toggleModalVisibility(val);
                    })}
                  />
                </div>
              )}
            </S.ContentPopButton>
          )}
        </S.ContentButton>
      </S.ContentSearch>

      <CreateFrame
        isOpenModal={isOpenModal("create")}
        setModalClose={() => toggleModalVisibility("create")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateSupplier
        isOpenModal={isOpenModal("supplier")}
        setModalClose={() => toggleModalVisibility("supplier")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateBrainds
        isOpenModal={isOpenModal("brainds")}
        setModalClose={() => toggleModalVisibility("brainds")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateMaterial
        isOpenModal={isOpenModal("material")}
        setModalClose={() => toggleModalVisibility("material")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateLens
        isOpenModal={isOpenModal("lens")}
        setModalClose={() => toggleModalVisibility("lens")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateAntiGlare
        isOpenModal={isOpenModal("anti-glare")}
        setModalClose={() => toggleModalVisibility("anti-glare")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateTypeLens
        isOpenModal={isOpenModal("type-lens")}
        setModalClose={() => toggleModalVisibility("type-lens")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateSensitivity
        isOpenModal={isOpenModal("sensitivity")}
        setModalClose={() => toggleModalVisibility("sensitivity")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateLaboratory
        isOpenModal={isOpenModal("laboratory")}
        setModalClose={() => toggleModalVisibility("laboratory")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateExpenses
        isOpenModal={isOpenModal("expense")}
        setModalClose={() => toggleModalVisibility("expense")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateCategory
        isOpenModal={isOpenModal("category-expense")}
        setModalClose={() => toggleModalVisibility("category-expense")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateSurfacing
        isOpenModal={isOpenModal("surfacing")}
        setModalClose={() => toggleModalVisibility("surfacing")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateDiameter
        isOpenModal={isOpenModal("diameter")}
        setModalClose={() => toggleModalVisibility("diameter")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateIndice
        isOpenModal={isOpenModal("index")}
        setModalClose={() => toggleModalVisibility("index")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateHeight
        isOpenModal={isOpenModal("height")}
        setModalClose={() => toggleModalVisibility("height")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateRetr
        isOpenModal={isOpenModal("retroactive-sale")}
        setModalClose={() => toggleModalVisibility("retroactive-sale")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <Toast
        openToast={isOpenModal('open-toast')}
        closeToast={() => toggleModalVisibility('open-toast')}
        message={toastData.message}
        status={toastData.status}
      />
    </S.Container>
  );
}
